export default "__VITE_ASSET__1ad34700__"